import { FC, useEffect, useRef } from "react";
import { AccessPointFilterPanel } from "@app/projects/network-assessment/provider-hub/provider-profile/AccessPointFilterPanel";
import { AccessPointFilterState, ServicingAccessPoint } from "@app/projects/network-assessment/provider-hub/interfaces";
import { QESButton } from "@app/shared/qes-standards/Button";

interface AccessPointFilterModalProps {
  allAccessPoints: readonly ServicingAccessPoint[];
  filterState: AccessPointFilterState;
  onChange: (next: AccessPointFilterState) => void;
  onClearFilters: () => void;
  onClose: () => void;
  showLocationConfidence: boolean;
  showTerminated: boolean;
  triggerRef: React.RefObject<HTMLElement>;
}

export const AccessPointFilterModal: FC<AccessPointFilterModalProps> = ({
  allAccessPoints,
  filterState,
  onChange,
  onClearFilters,
  onClose,
  showLocationConfidence,
  showTerminated,
  triggerRef,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const target = e.target as Node;
      if (
        modalRef.current &&
        !modalRef.current.contains(target) &&
        (!triggerRef.current || !triggerRef.current.contains(target))
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [onClose, triggerRef]);

  return (
    <div className="provider-profile__ap-filter-modal" ref={modalRef}>
      <AccessPointFilterPanel
        allAccessPoints={allAccessPoints}
        filterState={filterState}
        onChange={onChange}
        showLocationConfidence={showLocationConfidence}
        showTerminated={showTerminated}
      />
      <hr className="provider-profile__ap-filter-modal-separator" />
      <div className="provider-profile__ap-filter-modal-footer">
        <QESButton
          className="provider-profile__ap-filter-modal-clear-all"
          onClick={onClearFilters}
          qesTestId="ap-filter-modal-clear-all"
          qesType="none"
        >
          Clear all filters
        </QESButton>
      </div>
    </div>
  );
};
